import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  clearSelectedSteward,
  updateSelectedRider,
  updateSelectedSteward,
} from "../../../../../reducer/posReducer/restaurant";

import Restaurant from "./PosHeader/Restaurant";
import { POS_TYPE } from "../../../../../utils/posHelper";

function HeaderRevamped({ headerName }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { hotelDetails } = useSelector((store) => store.login);
  const [isSteward, setIsSteward] = useState(false);
  const tableOrderDetails = useSelector((state) => state.pos.tableOrder);
  const { selectedSteward, selectedRider } = useSelector((store) => store.pos);

  const { data, allOrdersData } = useSelector((store) => store.order);

  const { response, activePosSlug, activePosType } = useSelector(
    (store) => store.posSetting,
  );

  const stewards = useMemo(() => {
    return (
      response?.find((item) => item.slug === activePosSlug)?.stewards ?? []
    );
  }, [response, activePosSlug]);

  useEffect(() => {
    dispatch(clearSelectedSteward());

    if (data?.length) {
      assignSteward(data);
    } else {
      assignSteward(allOrdersData, true);
    }
  }, [data, allOrdersData, stewards]);

  const assignSteward = (orders = [], initializeAllStewards = false) => {
    const stewardCount = {};
    const validStewards = new Set(stewards);

    if (initializeAllStewards) {
      stewards.forEach((steward) => {
        stewardCount[steward] = 0;
      });
    }

    orders.forEach((order) => {
      (order?.stewardNames || []).forEach((steward) => {
        if (!validStewards.has(steward)) return;

        stewardCount[steward] = (stewardCount[steward] || 0) + 1;
      });
    });

    const sorted = Object.entries(stewardCount).sort(([, a], [, b]) => a - b);

    dispatch(updateSelectedSteward(sorted.length ? sorted[0][0] : ""));
  };

  const dispatch = useDispatch();

  const handleRider = (e) => dispatch(updateSelectedRider(e));

  const styles = {
    fontSize: 12,
  };

  return (
    <div className="w-full flex items-center justify-between py-6 px-8 shadow-md bg-white mt-[1.1rem] ">
      <div className="text-[32px] text-fg-secondary col-span-1 capitalize">
        {headerName?.length > 20
          ? headerName?.substring(0, 20) + "..."
          : headerName}
      </div>

      {activePosType === POS_TYPE[0] && (
        <Restaurant
          stewardList={stewards}
          tableOrderDetails={tableOrderDetails}
          selectedSteward={selectedSteward}
          isSteward={isSteward}
          setIsSteward={setIsSteward}
          hotelDetails={hotelDetails}
          handleRider={handleRider}
          styles={styles}
          selectedRider={selectedRider}
        />
      )}
    </div>
  );
}

export default HeaderRevamped;
